import React, { Component } from 'react'
import axios from 'axios'
import Messages from './Messages'
import Cookies from 'universal-cookie'
import { v4 as uuid } from 'uuid'

// const FULL = 'fulfillmentMessages'

const cookies = new Cookies()

class ChatBot extends Component {
  messagesEnd
  talkInput
  constructor(props) {
    super(props)
    this.state = {
      messages: [],
      phoenix: {
        text: []
      }
    }
    if (cookies.get('userID') === undefined) {
      cookies.set('userID', uuid(), { path: '/' })
    }
  }

  componentDidMount() {
    this.df_event_query('Welcome')
  }

  componentDidUpdate(prevProps, prevState) {
    this.messagesEnd.scrollIntoView({ behavior: 'smooth' })
    this.talkInput && this.talkInput.focus && this.talkInput.focus()
  }

  async df_text_query(text) {
    let says = {
      speaks: 'me',
      msg: {
        text: {
          text: text
        }
      }
    }
    this.setState({ messages: [...this.state.messages, says] })
    let url = 'https://inchatbot.herokuapp.com/api/df_text_query'
    if (process.env.NODE_ENV === 'development') {
      url = `/api/df_text_query`
    }
    const res = await axios.post(url, { text:text, userId: cookies.get('userID') })

    for (let msg of res.data.fulfillmentMessages) {
      says = {
        speaks: 'bot',
        msg: msg
      }
      this.setState({ messages: [...this.state.messages, says] })
    }
  }

  async df_event_query(event) {
    let url = 'https://inchatbot.herokuapp.com/api/df_event_query'
    if (process.env.NODE_ENV === 'development') {
      url = `/api/df_event_query`
    }
    const res = await axios.post(url, { event, userId: cookies.get('userID') })

    for (let msg of res.data.fulfillmentMessages) {
      let says = {
        speaks: 'me',
        msg: msg
      }
      this.setState({ messages: [...this.state.messages, says] })
    }
  }

  renderMessages = stateMessages => {
    if (stateMessages) {
      return stateMessages.map((message, i) => {
        return (
          <Messages
            key={i}
            speaks={message.speaks}
            text={message.msg.text.text}
          />
        )
      })
    }
    return null
  }

  _handleInputKeyPress = e => {
    if (e.key === 'Enter') {
      this.df_text_query(e.target.value)
      e.target.value = ''
    }
  }

  renderInput = () => {
    return (
      <input
        type="text"
        ref={input => {
          this.talkInput = input
        }}
        onKeyPress={this._handleInputKeyPress}
      />
    )
  }

  render() {
    return (
      <div>
        <div
          style={{
            height: 520,
            width: 370,
            float: 'right',
            border: '1px solid darkgrey'
          }}
        >
          <div
            id="chatbot"
            style={{ height: '100%', width: '100%', overflow: 'auto' }}
          >
            <div>ChatBot</div>
            {this.renderMessages(this.state.messages)}

            <div
              ref={el => {
                this.messagesEnd = el
              }}
              style={{ float: 'left', clear: 'both' }}
            />
            {this.renderInput()}
          </div>
        </div>
      </div>
    )
  }
}

export default ChatBot
